import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { JobBoardsSearchHistoryComponent } from './job-boards-search-history.component';

@NgModule({
  declarations: [JobBoardsSearchHistoryComponent],
  imports: [
    CommonModule,
    AccordionModule.forRoot(),
    InfiniteScrollModule,
    PipesModule
  ],
  exports: [JobBoardsSearchHistoryComponent],
  entryComponents: [JobBoardsSearchHistoryComponent]
})
export class JobBoardsSearchHistoryModule { }
